import { company_name } from "@/i18n/variables";

const password_vault = {
	add_button: "Share Password",
	description: {
		href: "https://support.tuxis.nl/en/knowledgebase/article/never-forget-your-password-again",
		text: `${company_name}, or another user within your organization, has shared the passwords below with you for your review. <strong>These are visible for 30 days</strong>. Changing a password does not affect the service. You can also share passwords with ${company_name} and other users here. Do you want to avoid ever losing your passwords? Then read <a>this article</a>.`,
	},
	dialog_add: {
		description: "",
		title: "Shared login information",
	},
	dialog_delete: {
		description: "Are you sure you want to delete <strong>{{name}}</strong>?",
		title: "Delete Password",
	},
	dialog_update: {
		confirmation: {
			description:
				"Please note: The changes you make here will not affect the login credentials of the linked products or services.",
			title: "Update Shared Password",
		},
	},
	generate: "Generate",
	password_text:
		"The password is not associated with any service. This password is shared with you. Save it in your password manager.",
	status: {
		create_success: "Password successfully shared!",
		delete_success: "Password successfully deleted!",
		successful_copy_otp_secret: "2FA Secret copied to clipboard",
		successful_copy_password: "Password copied to clipboard",
		successful_copy_url: "Hostname/URL copied to clipboard",
		successful_copy_username: "Username copied to clipboard",
		update_success: "Password successfully updated!",
	},
	table: {
		actions: "Actions",
		description: "Description",
		expires_at: "Visible Until",
		name: "Name",
		not_visible: "Not visible",
		otp_secret: "2FA Secret",
		password: "Password",
		support_has_access: `${company_name} may view password`,
		url: "Hostname/URL",
		user_list: "Visible to",
		username: "Username",
	},
	title: "Shared passwords",
};

export default password_vault;
